'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { Venue } from '../../../../shared/models';

// Import ConciergeQuestionnaire
const ConciergeQuestionnaire = dynamic(() => import('../../concierge/concierge_inquiry'));

interface ConciergeHelpSectionProps {
    venue: Venue;
}

const ConciergeHelpSection: React.FC<ConciergeHelpSectionProps> = ({ venue }) => {
    const [conciergeInquiryOpen, setConciergeInquiryOpen] = useState(false);

    const handleOpenConciergeInquiry = () => {
        setConciergeInquiryOpen(true);
    };

    const handleCloseConciergeInquiry = () => {
        setConciergeInquiryOpen(false);
    };

    if (!venue?.Enabled) return null;

    return (
        <>
            {/* Concierge Help Section */}
            <div className="w-full mt-16 p-6 md:p-8 bg-white/5 rounded-3xl text-center">
                <h2 className="font-['Roboto_Condensed'] text-3xl md:text-4xl text-white mb-4">
                    Not sure if this is right for you? Let us help
                </h2>
                <p className="font-['Inter'] text-lg md:text-xl text-gray-300 mb-6 max-w-2xl mx-auto">
                    Give us a few details and we'll send you 3 perfect venues in under 24 hours — for free.
                </p>
                <button
                    onClick={handleOpenConciergeInquiry}
                    className="py-4 px-12 text-lg rounded-full bg-[#C0C0DD] text-[#1C1C34] font-bold font-['Inter'] shadow-lg hover:bg-[#AEAEAE] hover:scale-105 active:scale-95 transition-all duration-200 ease-in-out"
                >
                    Get Perfect Venue Recommendations
                </button>
            </div>

            {/* ConciergeQuestionnaire Modal */}
            <ConciergeQuestionnaire
                open={conciergeInquiryOpen}
                onClose={handleCloseConciergeInquiry}
            />
        </>
    );
};

export default ConciergeHelpSection; 